// Canonical Florida regions and their sub-tag mappings.
// Backend data (resources, events) uses fine-grained tags like "Central FL", "NE FL",
// "West FL", "SW FL", "Panhandle". This lib maps those to 4 primary regions the user picks.

export const REGIONS = [
  { key: "all", label: "All Florida", short: "All" },
  { key: "panhandle", label: "Panhandle", short: "Panhandle" },
  { key: "north", label: "North Florida", short: "North" },
  { key: "central", label: "Central Florida", short: "Central" },
  { key: "south", label: "South Florida", short: "South" },
];

// Fine-grained tags that each primary region includes.
// Update this map if new sub-region tags are ever added to the resources data.
export const REGION_TAG_MAP = {
  panhandle: ["Panhandle"],
  north: ["North FL", "NE FL"],
  central: ["Central FL", "West FL"],
  south: ["South FL", "SW FL"],
};

// The full set of "regional" sub-tags across all regions — used to identify
// which items are region-scoped vs. statewide.
const ALL_REGIONAL_TAGS = new Set(
  Object.values(REGION_TAG_MAP).flat().map((t) => t.toLowerCase())
);

const norm = (s) => (s || "").toLowerCase().trim();

/**
 * Return true when the given item is region-scoped (has at least one recognized
 * regional sub-tag). Items without any regional tag are treated as statewide.
 */
export function isRegionScoped(item) {
  const tags = (item?.tags || []).map(norm);
  return tags.some((t) => ALL_REGIONAL_TAGS.has(t));
}

/**
 * Filter a list of items by primary region.
 * - `region === "all"` → returns items unchanged.
 * - Otherwise: keeps items whose tags include ANY of the region's sub-tags,
 *   AND keeps statewide items (items with no recognized regional tag at all).
 */
export function filterByRegion(items, region) {
  if (!Array.isArray(items) || !items.length) return items || [];
  if (!region || region === "all") return items;
  const wanted = new Set((REGION_TAG_MAP[region] || []).map(norm));
  if (!wanted.size) return items;
  return items.filter((item) => {
    if (!isRegionScoped(item)) return true; // statewide — always show
    const tags = (item.tags || []).map(norm);
    return tags.some((t) => wanted.has(t));
  });
}

export function regionLabel(key) {
  return (REGIONS.find((r) => r.key === key) || REGIONS[0]).label;
}
